<template>
  <div>
    <screening-item ref="screeningRef" @screeningItemNum="projectChange"></screening-item>
    <div class="page-title">{{isQianchuan?'千川':'头条'}}</div>
    <!-- 表单查询 -->
    <el-form ref="queryFormRef" class="query-form" label-width="80px" :model="queryForm" inline>
      <div>
        <el-form-item label="日期范围">
          <el-date-picker @change="changeTime"
            v-model="timeDate"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="筛选">
          <el-select style="width: 200px" v-model="queryForm.accountName" @change="changeTime" filterable clearable placeholder="请选择投放账户">
            <el-option
              v-for="item in accountData"
              :key="item.agentAccountId"
              :label="item.agentAccountName"
              :value="item.agentAccountName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-select style="width: 120px" v-model="queryForm.operateTargetType" @change="changeTime" clearable placeholder="操作维度">
            <el-option :value="1" label="账户"></el-option>
            <el-option :value="2" label="广告组"></el-option>
            <el-option :value="3" label="计划"></el-option>
            <el-option :value="4" label="创意"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-select style="width: 150px" v-model="queryForm.operatorId" @change="changeTime" filterable clearable placeholder="操作人">
            <el-option
              v-for="item in operatorLists"
              :key="item.employeeId"
              :label="item.employeeName"
              :value="item.employeeId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-select style="width: 150px" v-model="queryForm.operateLogType" @change="changeTime" clearable placeholder="请选择日志类型">
            <el-option :value="1" label="常规"></el-option>
            <el-option :value="2" label="智能投放"></el-option>
            <el-option :value="3" label="克隆" v-if="!isQianchuan"></el-option>
          </el-select>
        </el-form-item>
        <!-- <div class="searchBox">
          <el-input v-model="queryForm.operateTargetName" placeholder="请输入关键字"></el-input>
          <el-button @click="changeTime"><i class="iconfont icon-sousuo"></i></el-button>
        </div> -->
        <el-form-item label="">
          <el-input placeholder="请输入关键字" v-model="queryForm.operateTargetName" class="input-with-search">
            <el-button @click="changeTime" slot="append" icon="iconfont icon-sousuo"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button @click="resetForm" size="medium" type="info">重置选项</el-button>
        </el-form-item>
      </div>
      <div style="padding-left: 80px;">
        <!-- <el-form-item label="">
          <el-input placeholder="请输入关键字" v-model="queryForm.operateTargetName" class="input-with-search">
            <el-button @click="changeTime" slot="append" icon="iconfont icon-sousuo"></el-button>
          </el-input>
        </el-form-item> -->

      </div>
    </el-form>
    <!-- 表格 -->
    <el-table
      class="roleTable"
      :data="allData.pageData" v-loading="tableLoading"
      border style="width: 100%">
      <el-table-column
       width="180"
        prop="createTime"
        label="操作时间">
      </el-table-column>
      <el-table-column
        prop="agentAccountName"
        label="投放账户">
        <template slot-scope="scope">
          {{scope.row.agentAccountName}}({{scope.row.agentAccountId}})
        </template>
      </el-table-column>
      <el-table-column
        width="80"
        prop="operateTargetType"
        label="操作维度">
        <template slot-scope="scope">
          {{operateTargetTypeList[scope.row.operateTargetType]}}
        </template>
      </el-table-column>
      <el-table-column
        prop="operateTargetName"
        label="名称/ID">
        <!-- <template slot-scope="scope">
          <div v-if="scope.row.operateTargetType !== 4">{{scope.row.operateTargetName}}</div>
          <div v-else>-</div>
        </template> -->
      </el-table-column>
      <el-table-column
       width="100"
        prop="operateLogType"
        label="日志类型">
        <template slot-scope="scope">
          <div v-if='scope.row.operateLogType == 1'>常规</div>
          <div v-else>智能投放</div>
        </template>
      </el-table-column>
      <el-table-column
        width="100"
        prop="operateEventType"
        label="操作内容">
        <template slot-scope="scope">
          {{operateEventTypeList[scope.row.operateEventType]}}
        </template>
      </el-table-column>
      <el-table-column
        width="150"
        prop="operatorName"
        label="操作人">
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="paging-box" v-if="pageTotal > 0">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="queryForm.pageNum"
        :page-size="queryForm.pageSize"
        layout="total, prev, pager, next"
        :total="pageTotal">
      </el-pagination>
    </div>
  </div>
</template>

<script>
// 公用
import { mapGetters } from 'vuex'
import { getTimeAll, getTime } from '@/components/public'
export default {
  name: 'operationLog',
  data () {
    return {
      tableLoading: true,
      timeDate: [getTime(new Date()), getTime(new Date())],
      // 查询表单
      queryForm: {
        projectId: 0,
        createTimeStart: getTime(new Date()),
        createTimeEnd: getTime(new Date()),
        accountName: '',
        operateTargetType: '', // 操作维度
        operatorId: '', // 操作人员ID
        operateLogType: '', // 日志类型
        operateTargetName: '',
        // 分页
        pageNum: 1,
        pageSize: 10 // 每页显示的数据条数
      },
      // 分页
      pageTotal: 0,
      // 选择投放账户
      accountData: [],
      // 选择操作人
      operatorLists: [],
      operateTargetTypeList: ['', '账户', '广告组', '计划', '创意'], // 操作维度
      operateEventTypeList: ['', '授权', '修改日预算', '新建广告组', '修改广告组名称', '修改广告组状态', '删除广告组', '修改广告组预算', '新建计划', '修改计划名称', '修改计划状态', '删除计划', '修改计划日预算', '修改计划出价', '修改计划时间', '修改计划时段', '新建创意', '修改创意状态', '删除创意'], // 操作事件类型
      // 表格数据
      allData: {}
    }
  },
  created () {
    this.adReportListData()
    this.getAccountList() // 获取账户下拉框数据
    this.operatorList() // 操作人
  },
  watch: {
  },
  computed: {
    ...mapGetters(['screeningProduct', 'screeningProject']),
    isQianchuan() {
      return this.$route.path.startsWith('/qianchuan')
    }
  },
  methods: {
    // 切换项目筛选
    projectChange () {
      this.adReportListData()
      this.getAccountList() // 获取账户下拉框数据
      this.operatorList() // 操作人
      this.queryForm.accountName = ''
      this.queryForm.operatorId = ''
    },
    // 切换分页
    handleCurrentChange (val) {
      this.adReportListData()
    },
    // 获取查询数据
    adReportListData () {
      if (this.timeDate) {
        this.queryForm.createTimeStart = this.timeDate[0]
        this.queryForm.createTimeEnd = this.timeDate[1]
      } else {
        this.queryForm.createTimeStart = ''
        this.queryForm.createTimeEnd = ''
      }
      this.queryForm.projectId = this.screeningProject
      this.queryForm.platformType = parseInt(localStorage.platformType)
      // 开启tableLoading
      this.tableLoading = true
      this.$service.post('/api/operation/list', this.queryForm).then(res => {
        if (res.code === 200) {
          // 关闭tableLoading
          this.tableLoading = false
          this.allData.pageData = res.result.pageData
          this.pageTotal = res.result.total
          this.allData.pageData.forEach((item, index) => {
            item.createTime = getTimeAll(new Date(item.createTime))
          })
        }
      }).catch(Err => {})
    },
    // 选择时间获取表格数据
    changeTime () {
      this.queryForm.pageNum = 1
      this.adReportListData()
    },
    // 筛选下拉框选择
    getAccountList () {
      this.$service.post('/api/creativeComponent/getAccountListByProjectId', {projectId: this.screeningProject}).then(res => {
        if (res.code === 200) {
          this.accountData = res.result
        }
      }).catch(Err => {})
    },
    // 操作人
    operatorList () {
      this.$service.post('/api/tagPack/createorList', {projectId: this.screeningProject}).then(res => {
        if (res.code === 200) {
          this.operatorLists = res.result.employeeData
        }
      }).catch(Err => {})
    },
    // 重置选项
    resetForm () {
      this.queryForm = {
        createTimeStart: getTime(new Date()),
        createTimeEnd: getTime(new Date()),
        accountName: '',
        operateTargetType: '', // 操作维度
        operatorId: '', // 操作人员ID
        operateLogType: '', // 日志类型
        operateTargetName: '',
        // 分页
        pageNum: 1,
        pageSize: 10 // 每页显示的数据条数
      }
      this.accountData = []
      this.timeDate = [getTime(new Date()), getTime(new Date())]
      this.getAccountList()
      this.operatorList()
      this.adReportListData()
    }
  }
}
</script>

<style lang="less" scoped>
.query-form{
  margin-bottom: -21px;
}
</style>



// WEBPACK FOOTER //
// src/views/monitor/operationLog.vue